


//import {browserHistory as history} from 'react-router'
import {Link} from 'react-router-dom'
import SuccessCom from '../../core/AbodeSuccessTag'

import CreateStoredcardFormBusCom from './CreateStoredcardFormBusCom'
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';
import MotelTerrain from '../../terrain/MotelTerrain'
import ErrorCom from '../../core/AbodeErrorTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner'
import history from "../../../history"



import '../../../css/svformwerror.css'
//const {Link} = require("react-router")

/*
import { createBrowserHistory } from "history"

const history = createBrowserHistory();
*/

let sv_my_data_geo ={}

const React = require('react')
const _ = require('lodash')
const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );


const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

class SVStoredcardontainer extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(this) 
        this.closecbParent = this.closecbParent.bind(this)
        this.closecbParentSuccess = this.closecbParentSuccess.bind(this)
        this.title = 'AddressContainer'
        this.svsubmitparent = this.svsubmitparent.bind(this)
        this.getChildBody = this.getChildBody.bind(this)
        this.getChildContainersDetail = this.getChildContainersDetail.bind(this)
        
      
    }

    componentWillMount()	{
        console.log('sv--storedCardContainerJ#!***31 get my_data_geo params from Router')
        console.log(this.props.svparams)
         //console.log(this.props.svparams.id)
         let id;
         let svCustomerId = -14
         if(this.props.svparams){
            id = this.props.svparams.cardId
            svCustomerId = this.props.svparams.id
            console.log(id, svCustomerId)
         
         }else{
          console.log('not called by router we might be creat')
          id = -11;
         }
        
    console.log('sbv--sjourn id ****SVJ2!+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
    
    const { cookies } = this.props;
    this.getAppDetails(id, cookies.get('svt'))
       // this.props.priceAndTexNow(id);
   
			
			
	

	}
  closecbParentSuccess(){
    let svCustomerId = this.props.svparams.id
    console.log('svCustomerId*********')
    console.log(svCustomerId)
    history.push(`/myaccountSV/${svCustomerId}/mystoredcardList`)

  }
  closecbParent(){
    let svCustomerId = this.props.svparams.id
    console.log('svCustomerId*********')
    console.log(svCustomerId)
    history.push(`/myaccountSV/${svCustomerId}/mystoredcardList`)
  }

    getAppDetails(paramQSpaceId,svtv){
        //loadStoredcardDet(id)
        let id = -1
        if(paramQSpaceId ){
            id  = parseInt(paramQSpaceId)
        }
       if(id < 0){
            console.log("id*  cerate ******", id)
            /*
            const resetData = {
              "id": id
             }
            this.props.svLoadStoredcarddetReset(resetData)
            */
           /*svj31 start*/
           this.props.createResetFlagsStoredcardDet()
         
           /*svj31 end*/
        
      }else{

        console.log("id* SVJ31 ***loadStoredcardDetSecure det or edit******", id)
        this.props.loadStoredcardDetSecure(id, svtv)
      }
        console.log("id* SVJ23 my_data_geo addressr det or edit******", id)
        console.log(this.props)
        //this.props.loadStoredcardDet(id)
       


       // this.props.loadStoredcardDetSecure(id, svtv)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    svsubmitparent(values){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      console.log(values)
      ///essearch/spaceBookNow
      //get props.state 
      //console.log(this.props.my_data_traveller)
      if(values ){
          let full_name = ""
          if(  values[ "fname"]){
            full_name =  values[ "fname"]
          }
          if(  values[ "lname"]){
            full_name =  " " + values[ "lname"]
          }
        values[ "name"] =   values[ "name"] ? values[ "name"]:'ca'
        values[ "state"] =   values[ "state"] ? values[ "state"]:'ca'
        values[ "country"] =   values[ "country"] ? values[ "country"]:'usa'
        values[ "customerId"] =  values[ "customerId"] ? values[ "customerId"]:6
          /*
          values[ "rentcar"] =   values[ "rentcar"] ? "Y":'N'
          values[ "bookTaxi"] =   values[ "bookTaxi"] ? "Y":'N'
          values[ "needFlight"] =   values[ "needFlight"] ? "Y":'N'
          values[ "privateparking"] =   values[ "privateparking"] ? "Y":'N'
          */
          values[ "otherDetails"] =   values[ "otherDetails"] ?  values[ "otherDetails"]:"UI HardCoded SVMed facility"
      }
      let comCardAndTraveller = {
        cardNew : values
       
      }  
      const { cookies } = this.props;
     return this.props.addStoredcardNowSecure(comCardAndTraveller, cookies.get('svt'))
  
    }

    getChildBody(){
      console.log('*******SVJ31***astorecard container')
      const lastestUpdateDate = 'Data Refresh Daily'

        const { title, svsubmitparent} = this
        /*svj31 start*/
        const {my_data_geo } = this.props
        sv_my_data_geo = my_data_geo
        console.log('*******SVJ31***astored catr my_data_geo', my_data_geo)
        /*svj31 end*/
        let svCustomerId = -14
        let id = -12
        if(this.props.svparams){
         // id = this.props.svparams.cardId
          svCustomerId = this.props.svparams.id
          console.log(id, svCustomerId)
       
       }else{
        console.log('not called by router we might be creat')
        id = -11;
       }
        let det = {
            "id": -1,
            "cardId": -1,
            "customerId": svCustomerId,
            "paymentMethodCode": "card",
            "paymentType": "self",
            "productDetails": "svr",
            "description": "CHASE Card",
            "cardNumber": "4443412341234123",
            "cardCvv": "444",
            "cardExpMonth": "08",
            "cardExpYear": "22",
            "email": "alen@br.com",
            "isValid": "Y",
            "cardDelete": "N",
            "cardBlock": "N",
            "fname": "John",
            "lname": "Glen",
            "email": "john123@yahoo.com",
            "address": "12 scotland av",
            "city": "Albany",
            "state": "New York",
            "zip": "12110",
            "country": "USA",
            "isdcode": "+1",
            "phone": "5121234356"
        }
        if (this.props.my_data_storedcarddet ) {
            det = this.props.my_data_storedcarddet
            det.customerId = svCustomerId
            
          
        }
        let hasErrorOrSuccess = false
        const {errob, crudsuccessob} = this.props
        if(this.props.error){
          if(errob && (errob.status > 0 ) && (errob.message.length > 0 )){
            hasErrorOrSuccess = true
          }
          if(crudsuccessob && (crudsuccessob.status ==  200 ) && (crudsuccessob.message.length > 0 )){
            hasErrorOrSuccess = true
          }
        }
      const svmsg = "There is error . Plese try later"
       if(this.props.error  && ( hasErrorOrSuccess == true )){
         console.log('sv**container SVJ31  my_data_geo ger errob')
         console.log(this.props)
         if(crudsuccessob &&  (crudsuccessob.status == 200)){

          console.log('sv**container ger crud_flag')
          return(
            <div >
                
              <div style={{paddingTop:'10px'}}>
                <SuccessCom  svCustomerId={svCustomerId} closecbParentSuccess={this.closecbParentSuccess} crudsuccessob={this.props.crudsuccessob} ></SuccessCom>
              </div>
              <div style={{paddingTop:'10px'}}>
                  <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${svCustomerId}/mystoredcardList`}> My Stored Cards   </Link></SVAButton>
              </div>
          
            </div>   
            
          )

         }

         if(errob &&  (errob.status != 200)){
            return (
              <div >
                
                  <div style={{paddingTop:'10px'}}>
                    <ErrorCom closecbParent={this.closecbParent}  errob={this.props.errob} ></ErrorCom>
                  </div>
                  <div style={{paddingTop:'10px'}}>
                      <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${svCustomerId}/mystoredcardList`}> My Storedcards   </Link></SVAButton>
                  </div>
                
              </div>   
                )
        }
       }else if(this.props.loading ){
        return (

        
          <div >
          <h3>Spinner*****</h3>
         <div style={{paddingTop:'10px'}}>

         <SVAbodeSpinner />
         </div>
 
      </div>   


        
              )

       }else {
        console.log('sv**container ger CreatorModifyForm flad')
        
        console.log('svj15 storedontainer props track  my_data_geo IMP***')

        console.log(this.props)
        if(sv_my_data_geo && sv_my_data_geo.countryTypes && (sv_my_data_geo.countryTypes.length > 5) ){
          console.log('****SVJ31 storedontainer SUCCESS my_data_geo***')

          return (
            <div style={{paddingTop:'10px'}}>
                <CreateStoredcardFormBusCom my_data_geo={sv_my_data_geo} det={det}  svsubmitparent={svsubmitparent} onSubmit={svsubmitparent}></CreateStoredcardFormBusCom>
              {/* 
              <PaymentCardFormBusCom  onSubmit={svsubmitparent}   ></PaymentCardFormBusCom>
                   */}
                </div>   
                )
       
        }else{
          console.log('****SVJ31 storedontainer FAIL my_data_geo***')

          return (
            <div style={{paddingTop:'10px'}}>
                <CreateStoredcardFormBusCom my_data_geo={my_data_geo} det={det}  svsubmitparent={svsubmitparent} onSubmit={svsubmitparent}></CreateStoredcardFormBusCom>
              {/* 
              <PaymentCardFormBusCom  onSubmit={svsubmitparent}   ></PaymentCardFormBusCom>
                   */}
                </div>   
                )

        }

         
       }

    }

    getChildContainersDetail() {
      let svCustomerId = this.props.svparams.id
       
      return (
        <div className="svr-det-pageWrapper">
            <header className="svr-header1">
                      <h1><span><text style={{color:'#f0d8a9'}}> Stored Card Information </text><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
            </header>
           {this.getChildBody()}
           
         </div>   
           )   
    }

    renderOld() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title, svsubmitparent} = this
        let svCustomerId = -14
        let id = -12
        if(this.props.svparams){
         // id = this.props.svparams.cardId
          svCustomerId = this.props.svparams.id
          console.log(id, svCustomerId)
       
       }else{
        console.log('not called by router we might be creat')
        id = -11;
       }
        let det = {
            "id": -1,
            "cardId": -1,
            "customerId": svCustomerId,
            "paymentMethodCode": "card",
            "paymentType": "self",
            "productDetails": "svr",
            "description": "CHASE Card",
            "cardNumber": "4443412341234123",
            "cardCvv": "444",
            "cardExpMonth": "08",
            "cardExpYear": "22",
            "email": "alen@br.com",
            "isValid": "Y",
            "cardDelete": "N",
            "cardBlock": "N",
            "fname": "John",
            "lname": "Glen",
            "email": "john123@yahoo.com",
            "address": "12 scotland av",
            "city": "Albany",
            "state": "New York",
            "zip": "12110",
            "country": "USA",
            "isdcode": "+1",
            "phone": "5121234356"
        }
        if (this.props.my_data_storedcarddet ) {
            det = this.props.my_data_storedcarddet
            det.customerId = svCustomerId
            
          
        }
       /*to do we donot neeed care - terrain is card . just planin textstyel images page to hsow terrrain  */
    

       return (
        <div>
            <CreateStoredcardFormBusCom  det={det}  svsubmitparent={svsubmitparent} onSubmit={svsubmitparent}></CreateStoredcardFormBusCom>
            {/* 
            <PaymentCardFormBusCom  onSubmit={svsubmitparent}   ></PaymentCardFormBusCom>
                 */}
            </div>   
            )
        
    }

    render() {
      const lastestUpdateDate = 'Data Refresh Daily'
      const { title, orders} = this

      return (

          
          <div className="col-md-12">

              <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersDetail()}></MotelTerrain>
          </div>
      )

  }

}

export default SVStoredcardontainer